module.exports = __webpack_public_path__ + "static/gallery-project-success-1-9af48ca18487184c25d01a14655177c5.jpg";